import {
  MarketListing,
  Status,
} from '@wix/ambassador-devcenter-app-market-listing-v1-market-listing/types';

const statusesOrdering = {
  [Status.PUBLISHED]: 0,
  [Status.APPROVED]: 1,
  [Status.DRAFT]: 2,
};

const getStatusOrder = (status: Status | undefined) =>
  statusesOrdering[status as Status] || 3;

export const chooseAppListingToSaveByStatus = (
  newApp: MarketListing,
  oldApp?: MarketListing,
) => {
  if (!oldApp) {
    return newApp;
  }

  if (getStatusOrder(oldApp.status) > getStatusOrder(newApp.status)) {
    return newApp;
  }

  return oldApp;
};
